/* eslint-disable @typescript-eslint/no-unused-vars */
import { getPartnerComments } from './getPartnerComments.js';
import { VED_TYPES } from './VedField.js';
export const getFormatData = (data) => {
    const { acquiringType, onlineCheckout, posTerminal, amount, term, annualRevenue, serviceType, feedbackType, vedTypes, region, ...usedData } = data;
    const partnerComments = acquiringType || annualRevenue ? getPartnerComments(data) : null;
    const formatData = {
        ...usedData,
        ...getVedTypes(vedTypes),
        ...getRegion(region),
        ...(partnerComments ? { partnerComments } : {}),
        ...(serviceType ? { typeForm: serviceType } : {}),
        ...(feedbackType ? { typeForm: feedbackType } : {}),
    };
    return Object.fromEntries(Object.entries(formatData)?.map(([k, v]) => [k, v?.key || v]));
};
const getRegion = (region) => region?.key || region?.text ? { region: region?.text || region?.key } : {};
const getVedTypes = (vedTypes) => vedTypes
    ? {
        vedTypes: Object.fromEntries(VED_TYPES.map((v) => [v, v === vedTypes])),
    }
    : {};
//# sourceMappingURL=getFormatData.js.map